var map = {
	"./AdmissionRequest/index.vue": [
		"6395",
		"view-AdmissionRequest-index-vue"
	],
	"./AdmissionRequest/setting.vue": [
		"d6e0",
		"view-AdmissionRequest-setting-vue"
	],
	"./Album/images.vue": [
		"8b9a",
		"view-Album-images-vue"
	],
	"./Album/index.vue": [
		"ec28",
		"view-Album-index-vue"
	],
	"./Media/index.vue": [
		"bfea",
		"view-Media-index-vue"
	],
	"./News/form.vue": [
		"0cbc",
		"view-News-form-vue"
	],
	"./News/index.vue": [
		"5a69",
		"view-News-index-vue"
	],
	"./Notice/index.vue": [
		"28a1",
		"view-Notice-index-vue"
	],
	"./Photo/index.vue": [
		"cde9",
		"view-Photo-index-vue"
	],
	"./Quote/index.vue": [
		"3a70",
		"view-Quote-index-vue"
	],
	"./Service/index.vue": [
		"aa5c",
		"view-Service-index-vue"
	],
	"./Slider/backup.vue": [
		"2ba2",
		"view-Slider-backup-vue"
	],
	"./Slider/index.vue": [
		"652b",
		"view-Slider-index-vue"
	],
	"./Testimonial/index.vue": [
		"db2c",
		"view-Testimonial-index-vue"
	],
	"./Video/index.vue": [
		"0db9",
		"view-Video-index-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3fff";
module.exports = webpackAsyncContext;